import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { User, UserOnEntity } from "@/graphql/__generated__/graphql";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

interface Props {
  className?: string;
  user?: User | UserOnEntity;
  showTitle?: boolean;
  size?: "xs" | "sm" | "md" | "lg";
}

function UserAvatar({ className, user, showTitle, size = "lg" }: Props) {
  if (!user) {
    return <Skeleton className={cn("w-8 h-8 rounded-full", className)} />;
  }

  const sizeClass = {
    xs: "w-4 h-4",
    sm: "w-5 h-5",
    md: "w-6 h-6",
    lg: "w-8 h-8",
  }[size];

  const fallbackText = `${user.firstname?.charAt(0).toUpperCase()}${user.lastname?.charAt(0).toUpperCase()}`;
  const fullname = `${user.firstname} ${user.lastname}`;

  return (
    <Avatar className={cn("shrink-0", sizeClass, className)}>
      {user.picture ? (
        <LazyLoadImage
          className="rounded-full w-full h-full"
          src={user.picture}
          alt={fullname}
          referrerPolicy="no-referrer"
        />
      ) : (
        <AvatarFallback title={showTitle ? fullname : ""} className="text-xs">{fallbackText}</AvatarFallback>
      )}
    </Avatar>
  );
}

export default UserAvatar;
